package com.starparty.app.astro0

import kotlin.math.abs
import kotlin.math.pow
import kotlin.math.round

/**
 * Title:
 * Description:
 * Copyright:    Copyright (c) 2002
 * Company:
 * @author
 * @version 1.0
 */
class UMS {
    var units = 0.0
    var mins = 0.0
    var secs = 0.0
    var sign = 1

    constructor() {
    }

    constructor(sign:Int, units: Double, mins: Double, secs: Double) {
        this.sign = sign
        this.units = units
        this.mins = mins
        this.secs = secs
    }

    fun toString(
        decimalPlaces: Int,
        units1: String = ":",
        units2: String = ":",
        units3: String = ""
    ): String {

        val ten = 10.0
        val power = ten.pow(decimalPlaces)
        var roundedSecs = round(secs * power) / power

    /*    var seconds = secs.toString()
        val point = seconds.indexOf(".")
        if (point > 0) {
            if (decimalPlaces > 0) {
                seconds = seconds.substring(0, point + decimalPlaces + 1)
            }
            if (decimalPlaces == 0) {
                seconds = seconds.substring(0, point)
            }
        }*/

        var string = units.toString() + units1 + mins + units2 + roundedSecs + units3
        if (sign < 0){ string = "-$string" }

        return string
    }

    override fun toString(): String {
        var string = "$units:$mins:$secs"
        if (sign < 0){ string = "-$string" }

        return string
    }


    companion object {

        val HOUR = 0
        val UNITS = 0
        val DEG = 0
        val MIN = 1
        val SEC = 2
        val SIGN = 3


        fun hourMinSecToDecimalDegrees(hmsString: String): Double {
            return unitMinSecToDecimal(hmsString) * SP_Time.HOURS_TO_DEGS()
        }

        fun unitMinSecToDecimal(ums: UMS): Double {
            return unitMinSecToDecimal(
                ums.sign,
                ums.units,
                ums.mins,
                ums.secs
            )
        }

        fun unitMinSecToDecimal(umsString: String): Double {
            val ums = parseUMSString(umsString)
            return unitMinSecToDecimal(ums[3].toInt(), ums[0], ums[1], ums[2])
        }

        fun unitMinSecToDecimal(
            sign: Int,
            units: Double,
            min: Double,
            sec: Double
        ): Double {
            var decimal: Double = abs(units) +
                    min / SP_Time.HRS_TO_MINS() +
                    sec / SP_Time.HRS_TO_SECS()
            if (sign < 0) {
                decimal = -decimal
            }
            return decimal
        }

        fun degreesToHMS(degrees: Double): UMS {
            val hours: Double = degrees / SP_Time.HOURS_TO_DEGS()
            return unitsToUMS(hours)
        }

        fun degreesToDMS(degrees: Double): UMS {
            return unitsToUMS(degrees)
        }

        fun unitsToUMS(units: Double): UMS {
            val ums = UMS()
            ums.sign = if (units < 0) -1 else 1
            val posUnits: Double = abs(units)
            ums.units = posUnits.toInt().toDouble()
            val mins: Double = (posUnits - ums.units) * SP_Time.HRS_TO_MINS()
            ums.mins = mins.toInt().toDouble()
            val secs: Double =
                abs((mins - ums.mins) * SP_Time.MINS_TO_SECS())
            ums.secs = secs
            return ums
        }

        fun parseUMSStringToUMS(ums: String): UMS {
            val data = parseUMSString(ums)

            return UMS(
                data[UMS.SIGN].toInt(),
                data[UMS.HOUR],
                data[UMS.MIN],
                data[UMS.SEC]
            )
        }

        fun parseUMSString(ums: String): DoubleArray {
            val decimal = 0.0
            var negative = 1.0
            var ch = 0

            // Eat irrelevant characters.
            while ((ums[ch] < '0') || (ums[ch] > '9')) {
                if (ums[ch] == '-') negative = -1.0
                ch++
            }
            val NUM_OF_VALUES = 4
            val umsValues =
                  arrayOfNulls<StringBuilder>(NUM_OF_VALUES)
            createIndividualUMSStrings(ums, ch, umsValues)
            val umsDbls = DoubleArray(NUM_OF_VALUES)
            umsDbls[0] = umsValues[0].toString().toDouble()
            umsDbls[1] = umsValues[1].toString().toDouble()
            umsDbls[2] = umsValues[2].toString().toDouble()
            umsDbls[3] = negative
            return umsDbls
        }

        protected fun createIndividualUMSStrings(
            ums: String?,
            characterStartValue: Int,
            umsValues: Array<StringBuilder?>
        ) {
            var ch = characterStartValue
            for (v in umsValues.indices) {
                umsValues[v] = StringBuilder()
                while (ch < ums!!.length) {
                    val character = ums[ch]
                    if (((character >= '0') && (character <= '9')) || character == '.') {
                        umsValues[v]!!.append(ums[ch])
                    } else {
                        ch++
                        break
                    }
                    ch++
                }
            }
        }
    }
}